 

import { api } from './index';

import type { Thread, ThreadMessage } from '@/types';

export interface CreateAiChatThreadParams {
  assistantId?: string;
  userId?: string;
}

export interface GetAiChatThreadParams {
  threadId: string;
}

export interface AddMessageToThreadParams {
  threadId: string;
  content: string;
}

export interface GetResponsesFromThreadParams {
  threadId: string;
}

export const coachAiApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new AI chat thread
    createAiChatThread: builder.mutation<
      Thread,
      CreateAiChatThreadParams
    >({
      invalidatesTags: ['Thread'],
      query: (params) => ({
        method: 'POST',
        url: '/ai/threads/',
        data: params,
      }),
    }),

    // Get an AI chat thread
    getAiChatThread: builder.query<Thread, GetAiChatThreadParams>({
      providesTags: (_, __, { threadId }) => [
        { type: 'Thread', id: threadId },
        'Thread',
      ],
      query: ({ threadId }) => ({
        method: 'GET',
        url: `/ai/threads/${threadId}`,
      }),
    }),

    // Add a message to a thread
    addMessageToThread: builder.mutation<
      ThreadMessage,
      AddMessageToThreadParams
    >({
      invalidatesTags: (_, __, { threadId }) => [
        { type: 'Thread', id: threadId },
      ],
      query: ({ threadId, content }) => ({
        method: 'POST',
        url: `/ai/threads/${threadId}/post_message`,
        data: { content },
      }),
    }),

    // Get responses from a thread
    getResponsesFromThread: builder.mutation<
      ThreadMessage[],
      GetResponsesFromThreadParams
    >({
      invalidatesTags: (_, __, { threadId }) => [
        { type: 'Thread', id: threadId },
      ],
      query: ({ threadId }) => ({
        method: 'GET',
        url: `/ai/threads/${threadId}/get_responses`,
      }),
    }),
  }),
});

export const {
  useCreateAiChatThreadMutation,
  useGetAiChatThreadQuery,
  useAddMessageToThreadMutation,
  useGetResponsesFromThreadMutation,
} = coachAiApi;
